import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type ILocalStorage from './interfaces/ILocalStorage';

export const initialState: ILocalStorage = {
  processingValuesChainMapId: [],
};

const localStorageSlice = createSlice({
  name: 'localStorage',
  initialState,
  reducers: {
    setProcessingValuesChainMapId: (state, { payload }: PayloadAction<number>) => {
      if (state.processingValuesChainMapId.includes(payload)) {
        return;
      }

      state.processingValuesChainMapId = [...state.processingValuesChainMapId, payload];
    },
    removeProcessingValuesChainMapId: (state, { payload }: PayloadAction<number>) => {
      state.processingValuesChainMapId = state.processingValuesChainMapId.filter((id) => id !== payload);
    },
  },
});

export const { setProcessingValuesChainMapId, removeProcessingValuesChainMapId } = localStorageSlice.actions;

export default localStorageSlice.reducer;
